module.exports = __webpack_public_path__ + "img/icon-add.106a41da.svg";